import { store } from 'redux/store';

import { updateDocumentToDeleted } from 'utils/updateDocumentToDeleted';
import { updateBoard } from 'modules/boards/redux/boardActions';

type Props = {
  boardId: string;
  documentId: string;
  boardDocumentsIds: string[];
};

const getBoardUpdatedData = ({
  boardId,
  documentId,
  boardDocumentsIds,
}: Props) => {
  const filteredDocuments = boardDocumentsIds.filter(
    (document: string) => document !== documentId
  );

  const boardUpdateData = {
    _id: boardId,
    attachedDocuments: filteredDocuments,
  };

  return boardUpdateData;
};

export const handleRemoveBasicBoardDocument = async ({
  boardId,
  documentId,
  boardDocumentsIds,
}: Props) => {
  const boardUpdateData = getBoardUpdatedData({
    boardId,
    documentId,
    boardDocumentsIds,
  });

  await updateDocumentToDeleted(documentId);
  await store.dispatch(updateBoard(boardId, boardUpdateData, false));
};
